<template>
<div id="consulta_bitacora_archivosm">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container grid-list-md text-xs-center>

        <v-flex xs12>
            <base-material-card color="primary" icon="library_books" title="Bitácora de Archivos M" class="elevation-1 px-5 py-3">
                <br />

                        <v-card-text>


                                 <v-form ref="formreporte" lazy-validation>
                                <v-container grid-list-md text-xs-center>

                                    <v-row row wrap>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                        model.fecha_de = parseDate(model.fecha_de)
                                                                        " v-mask="'####-##-##'" :rules="[
                                                                        rules.required,
                                                                        validaDias,
                                                                        validaFecha,
                                                                        ]">
                                                    </v-text-field>
                                                </template>

                                                <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu1 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="4" lg="4">
                                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                            rules.required,
                                                            validaDias,
                                                            validaFecha,
                                                            ]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" large @click="menu2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Pedimento"
                                        ></v-switch>
                                          </v-col>
                                         <v-col sm="12" md="2" lg="2">
                                          &nbsp;
                                          </v-col>
                                    </v-row>
                                    <v-row row wrap>
                                        <v-col sm="12" md="8" lg="8" v-if="es_grupo==0">
                                            <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_seleccionado"
                                                :item-text="getNombreGrupo" item-value="rfc" clearable label="Seleccione Emisor" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="8" lg="8" v-else >
                                            <v-autocomplete :hide-no-data="true" :items="clientesTransportista" v-model="rfc_cliente_seleccionado"
                                                :item-text="getNombreCliente" item-value="rfc" clearable label="Seleccione Cliente" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            <v-btn rounded color="secondary" @click="cargar()" :loading="loadingReporte">
                                                <v-icon>search</v-icon>Consultar
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                      <v-chip
                            class="ma-2"
                        color="secondary"
                        outlined
                        >
                        <v-icon left>
                            mdi-information
                        </v-icon>
                         Consulta por rango de fechas, haciendo referencia a la fecha de proceso en que se carga el archivo ".zip" o por fecha de pedimento localizada en el archivo M

                        </v-chip>



                                </v-container>
                            </v-form>
                             <v-card-actions v-if="datafiltered.length>0">

                               <v-btn v-if="to_download.length > 0 && permiso_renombrar " rounded color="red" @click="modal_rename=true;">
                                 <v-icon>done</v-icon>Cambiar Referencia
                               </v-btn>
                               <v-btn v-if="to_download.length > 0 && permiso_asignar " rounded color="success" @click="modal_asignar_masivo=true;">
                                 <v-icon>done</v-icon>Asignar Transportista Masivo
                               </v-btn>
                                    <v-spacer></v-spacer>
                                    <exportar-excel :data="datos" :exportFields="data_resumen_excel" name="Bitacora_Archivos_M_Pendientes.xlsx">
                                        <v-btn icon small dark  color="success" title="Exportar Bitácora" v-tippy>
                                            <v-icon  dark>mdi-table</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </v-card-actions>

                                    <v-client-table id="vuetable" ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-5 ma-5" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <div slot="filter__id" >
                                          <input type="checkbox" class="form-control check-all" v-model='allChecked' @change="check_all()" >
                                        </div>
                                        <template slot="id" slot-scope="props">
                                          <div style="display:flex; justify-content:center;" >
                                            <input :id="props.row.id" type="checkbox" v-model="to_download" :value="props.row.id" ></input>
                                          </div>
                                        </template>

                                        <template slot="rfc_grupo" slot-scope="props" >
                                            <div v-if="es_grupo==0 && permiso_asignar" @click="openModalAsignar(props.row)"
                                                :class="['showPerfil']" >
                                                {{ getRfcGrupo(props.row.rfc_grupo) }}
                                            </div>
                                            <div v-else>
                                                {{ props.row.rfc_grupo }}
                                            </div>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                           <v-btn x-small text icon color="primary" title="Proforma ArchivoM"
                                                v-show="(props.row.key_pdf!=null && props.row.key_pdf!='')"
                                                @click="download_pdf(props.row.key_pdf)" v-tippy>
                                                <v-icon dark>picture_as_pdf</v-icon>
                                            </v-btn>
                                            <v-btn v-if="permiso_eliminar" x-small text icon color="red" title="Eliminar"  @click="eliminarBitacora(props.row.id)" v-tippy>
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                             <!--v-btn x-small text icon color="primary" title="Descargar Archivo ZIP"  @click="download(props.row)" v-tippy>
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn-->
                                              <v-btn x-small  text icon color="secondary" title="Consultar Adjuntos"  @click="lista = props.row; modal_docs=true;" v-tippy>
                                                <v-icon dark>mdi-folder-search</v-icon>
                                            </v-btn>

                                        </template>
                                    </v-client-table>



                        </v-card-text>


            </base-material-card>
        </v-flex>

    </v-container>

    <v-dialog v-model="modal_rename" min-width="30%" max-width="50%" >
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal" >
            <v-icon @click.native="modal_rename = false" class="white--text" >cancel</v-icon>&nbsp;
            <span class="subheading" >
              <strong>Cambiar Nombre de Referencia</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-form ref="formreferencia" lazy-validation>
          <v-text-field v-model="referencia_nueva" label="Nombre de Referencia Nueva" :rules="[rules.required]" ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="success" @click="guardar_refencia">Guardar</v-btn>
          <v-btn small @click="modal_rename = false" >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal_docs" max-width="500px" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_docs = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Documentos</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md text-xs-center>
                    <v-form ref="formgenerar" lazy-validation>
                        <v-card-text>
                            <v-container grid-list-md text-xs-center>

                                <h5>COVES</h5>

                                <ol id="example-1">
                                <li v-for="item in lista.coves">
                                    {{ item }}
                                </li>
                                </ol>


                                <h5>EDOCUMENTS</h5>


                                <ol id="example-1">
                                <li v-for="item in lista.eDocuments">
                                    {{ item }}
                                </li>
                                </ol>

                            </v-container>
                        </v-card-text>
                    </v-form>
                </v-container>
            </v-card-text>

        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_asignar" max-width="500px">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Asignar Transportista
                </v-card>
            </v-card-title>
            <v-card-text>
                <v-form ref="formAsignar" lazy-validation="">

                    <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_asignar"
                        :rules="[rules.required]" :item-text="getNombreGrupo" item-value="rfc"
                        label="Seleccione Transportista" ></v-autocomplete>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="row_selected={};modal_asignar = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="asignarTransportista();">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="modal_asignar_masivo" max-width="500px">
        <v-card>
            <v-card-title>
                <v-spacer></v-spacer>
                <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">receipt</v-icon>&nbsp;Asignar Transportista
                </v-card>
            </v-card-title>
            <v-card-text>
                <v-form ref="formAsignar" lazy-validation="">

                    <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_asignar"
                        :rules="[rules.required]" :item-text="getNombreGrupo" item-value="rfc"
                        label="Seleccione Transportista" ></v-autocomplete>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="row_selected={};modal_asignar_masivo = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="asignarTransportistaMasivo();">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>

</template>

<script>
import axios from "axios";

import moment from "moment";


export default {
    computed: {
        datafiltered() {
                let result = [];
            if (this.$refs.vuetable != null) {
               result = this.$refs.vuetable.allFilteredData.filter(r => r.proveedor != null );
                return result;
            } else {
               result = this.datos.filter(r => r.proveedor != null );
                return result;
            }
        },
        permiso_asignar(){
            return (
               this.valida_permiso("Emanifiesto.archivom.asignar") 
            );
        },
        permiso_renombrar(){
            return (
               this.valida_permiso("Emanifiesto.archivom.renombrar") 
            );
        },
         permiso_eliminar(){
            return (
               this.valida_permiso("Emanifiesto.archivom.cargar") 
            );
        }

    },

    created: function () {
        this.URL = this.$hostname ;
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");

        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc = [this.$local_storage.get("rfc_grupo")];
            this.es_grupo = 1;
            this.getClientesTransportista();
        } else {
            this.model.rfc = [this.$local_storage.get("rfc")];
            this.getTransportistas();
        }

        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
            this.permisoEliminar = true;
        }

        var f = new Date();
        var f_de = new Date();

        f_de.setDate(f_de.getDate() + 1);

        let y_de = f_de.getFullYear();
        let m_de = f_de.getMonth() + 1;
        let d_de = f_de.getDate();

        if (m_de < 10)
            m_de = '0' + m_de;
        if (d_de < 10)
            d_de = '0' + d_de;

        let y = f.getFullYear();
        let m = f.getMonth() + 1;
        let d = f.getDate();

        if (m < 10)
            m = '0' + m;
        if (d < 10)
            d = '0' + d;

        this.model.fecha_de = y + "-" + m + "-" + d;
        this.model.fecha_a = y_de + "-" + m_de + "-" + d_de;
    },

    data: () => ({
        modal_asignar_masivo: false,
        referencia_nueva: "",
        modal_rename: false,
        to_download: [],
        allChecked: false,
        row_selected:{},
        modal_asignar:false,
        rfc_grupo_asignar:"",
        es_grupo:0,
        gruposTransportistas:[],
        clientesTransportista:[],
        rfc_grupo_seleccionado:"",
        rfc_cliente_seleccionado:"",
        modal_docs: false,
        permisoEliminar: false,
        tab: null,
        lista: {
            'coves':[],
            'eDocuments':[]
        },
        data_table_impo: [],
        lista_filtrada: [],
        modal: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext",
            },
           
            {
                text: "Bitácora Archivos M",
                disabled: true,
                to: "",
            },
        ],

        datos: [],

        columns: [
            "id",
            "rfc_grupo",
            "rfc",
            "metadato",
            "fecha",
            "iniciales",
            "nombre_zip",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion",
            "rfc_cfdi",
            "error_pdf",
            "estatus",
            "actions",
        ],
        options: {
            filterable: [

                "rfc","metadato",
            "rfc_grupo",
            "fecha",
            "iniciales",
            "nombre_zip",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion","rfc_cfdi","error_pdf",
            "estatus",
            ],
            sortable: [
              "id",
                "rfc","metadato",
            "rfc_grupo",
            "fecha",
            "iniciales",
            "nombre_zip",
            "numero_archivo",
            "no_pedimento",
            "fecha_pedimento",
            "clave_pedimento",
            "tipo_operacion", "rfc_cfdi", "error_pdf",
            "estatus",
            ],

            headings: {
              "id":"",
                "rfc":"RFC Importador-Exportador",
                "metadato":"Nombre Corto",
                "rfc_grupo":"RFC Transportista",
                 "fecha":"Fecha",
                "iniciales":"Usuario",
                "nombre_zip":"Nombre de Referencia del Proceso",
                "numero_archivo":"Archivo M",
                "no_pedimento":"Número de Pedimento",
                "fecha_pedimento": "Fecha Pedimento",
                "clave_pedimento":"Clave de Documento",
                "tipo_operacion":"Tipo Operación",
                "rfc_cfdi":"Remitente",
                "error_pdf":"Error al generar Proforma",
                "estatus": "Estatus",
                actions: "Acciones",
            },
        },
        data_resumen_excel: {
                "RFC Transportista":"rfc_grupo",
                "RFC Importador-Exportador":"rfc",
                "Nombre Corto":"metadato",
               "Fecha": "fecha",
               "Usuario":"iniciales",
               "Origen Archivo":"origen",
               "Nombre de Referencia del Proceso":"nombre_zip",
               "Cantidad de Elementos": "cantidad_archivos",
               "Archivo M":"numero_archivo",
               "Número de Pedimento": "no_pedimento",
               "Fecha Pedimento":"fecha_pedimento",
               "Clave de Documento": "clave_pedimento",
               "Tipo Operación":"tipo_operacion",
               "Remitente":"rfc_cfdi",
                "Estatus": "estatus",
            },
        loading: true,
        loadingReporte: false,
        model: {
            rfc: [],
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            nombre: "",
            proveedor: "",
            archivos: [],
        },
        menu1: false,
        menu2: false,
        fecha_factura: false,

        rules: {
            required: (v) => !!v || "Este campo es requerido",
            numeric: (value) => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            },
        },

        modal: false,

    }),

  //  0-Creado, 1-Manifestacion Creada, 2-Duplicado, 3-Error al leer archivoM, 4-Error al crear la manifestación, 5-Manifestacion transmitida
    methods: {
         valida_permiso(permiso) {
          return (
              this.$local_storage.get(permiso) == 100 
            );
        },
        getNombreGrupo:function(row){
            return row.rfc+" - "+row.grupo;
        },

        getTransportistas: function(){
            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),
            };
            axios.post(this.$hostname+ "grupos/get_grupos_rfc/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.gruposTransportistas = res.data;

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        openModalAsignar: function(row){
            this.row_selected = row;
            if(row.rfc_grupo != null && row.rfc_grupo!="")
                this.rfc_grupo_asignar= row.rfc_grupo;
            else
                this.rfc_grupo_asignar="";
            this.modal_asignar = true;
        },

        asignarTransportista: function(){
            if(this.$refs.formAsignar.validate() ){
                if(this.rfc_grupo_asignar != this.row_selected.rfc_grupo){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                 //   console.log(this.row_selected);
                    let data = {
                        id: this.row_selected.id,
                        rfc_grupo: this.rfc_grupo_asignar
                    };
                    axios.post(this.$hostname + 'bandeja_temporal/asignar_archivom_transportista/', data)
                    .then(res => {
                        this.row_selected.rfc_grupo = this.rfc_grupo_asignar;
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El transportista se asignó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al asignar transportista. Intente nuevamente.",
                            footer: ""
                        });
                        console.log(err);
                    }).then(()=>{
                        this.modal_asignar = false;
                        this.row_selected = {};
                        this.$root.$dialogLoader.hide();
                    });
                } else {
                    this.modal_asignar = false;
                    this.row_selected = {};
                }
            }
        },
        asignarTransportistaMasivo: function(){
            if(this.$refs.formAsignar.validate() ){
                if(this.rfc_grupo_asignar != this.row_selected.rfc_grupo){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                 //   console.log(this.row_selected);
                    let data = {
                        id: this.to_download,
                        rfc_grupo: this.rfc_grupo_asignar
                    };
                    axios.post(this.$hostname + 'bandeja_temporal/asignar_archivom_transportista_masivo/', data)
                    .then(res => {
                        this.row_selected.rfc_grupo = this.rfc_grupo_asignar;
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El transportista se asignó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al asignar transportista. Intente nuevamente.",
                            footer: ""
                        });
                        console.log(err);
                    }).then(()=>{
                        this.modal_asignar_masivo = false;
                        this.row_selected = {};
                        this.$root.$dialogLoader.hide();
                        this.to_download = [];
                        this.cargar();
                    });
                } else {
                    this.modal_asignar_masivo = false;
                    this.row_selected = {};
                    this.to_download = [];
                }
            }
        },
        getRfcGrupo: function (val) {
            if (val !== null) return val;
            else return "Sin Seleccionar";
        },
        getNombreCliente:function(row){
            if(row.metadato!=null && row.metadato!="")
                return row.rfc+" - "+row.metadato;
            else
                return row.rfc+" - "+row.razon_social;
        },
        getClientesTransportista: function(){
            let data = {
                id_grupo: this.$local_storage.get("id_grupo"),
            };
            axios.post(this.$hostname+ "grupos/get_rfcs/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientesTransportista = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            let fecha = 0;
            if (this.fecha_factura )
                fecha = 1;


            let data = {
                rfc: this.model.rfc,
                es_grupo: this.es_grupo,
                fecha_de: this.model.fecha_de,
                fecha_a: this.model.fecha_a,
                fecha_pedimento : fecha
            };
            if(this.rfc_grupo_seleccionado!=null && this.rfc_grupo_seleccionado!="")
                data["rfc_emisor"] = this.rfc_grupo_seleccionado;
            else
                data["rfc_emisor"] = "";

            if(this.rfc_cliente_seleccionado!=null && this.rfc_cliente_seleccionado!="")
                data["rfc_cliente"] = this.rfc_cliente_seleccionado;
            else
                data["rfc_cliente"] = "";

            axios.post("https://apireportes.econnectpro.mx/reportes/get_bitacora_manifestacion_transportista/", data)
                .then(res => {
                  this.to_download = [];
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_pedimento = this.parseDate(this.datos[k].fecha_pedimento);
                            this.datos[k].fecha = this.parseDate(this.datos[k].fecha);
                        //    this.datos[k].proveedor = this.datos[k].proveedor==1:"WEB";"API";
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los registros",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        formatNumber: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                return ""
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        },

        validaFecha: function (fecha) {
            if (fecha == "Invalid date") return "Fecha no válida.";
            else return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },

        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },



        getEstatus: function (estatus) {
            var arr_estatus  = ["PROCESADO", "GENERADO", "DUPLICADO", "ARCHIVO NO VALIDO", "ERROR AL GENERAR", "MANIFESTACIÓN TRANSMITIDA"];
            if (estatus in arr_estatus) return arr_estatus[estatus];
            else return estatus;
        },


        parseDate(date) {
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
            this.model.pedimento = "";
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.model.archivo = "";
            this.listado = "";
            this.to_download=[];
        },

        eliminarBitacora: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        id: idreporte,
                    };
                    axios
                        .post(this.$hostname + "bandeja_temporal/delete_bitacora_manifestacion_transportista/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },

        download_pdf: function (key_pdf) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key_pdf,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        check_all: function() {
          let arr = this.allChecked ? this.datos.map(row =>  row.id) : [];

          if (arr.length == 0) {
            this.to_download = [];
          } else {
            for (var i = 0; i < arr.length; i++) {
              if (this.to_download.includes(arr[i])) {
                continue;
              } else {
                this.to_download.push(arr[i]);
              }
            }
          }
        },
        guardar_refencia: function() {
          if(this.$refs.formreferencia.validate()) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            let data = {
              "referencia": this.referencia_nueva,
              "registros": this.to_download,
              "tipo": "m"
            };

            axios
                .post(this.$hostname + "vucem/cambiar_referencia/", data)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "Los registros se cambiarón correctamente",
                        footer: "",
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cambiar los registros. Favor de comunicarse con soporte.",
                        footer: "",
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargar();
                    this.to_download = [];
                    this.referencia_nueva = "";
                    this.modal_rename = false;
                });
          }
        },
        download: function (row) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var key = row.rfc_grupo + "/archivosM/" + row.nombre_zip;
            if(row.key_s3 != null && row.key_s3!="")
                key = row.key_s3;
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

    },
};
</script>

<style scoped>

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
.showPerfil {
    cursor: pointer;
    border-bottom: 1px dotted blue;
}

.VueTables__id-filter-wrapper {
  display: hide;
}
</style>
